(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5476],{

/***/ 53784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IndexView */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5951);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var components_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89231);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var IndexView = function IndexView(props) {
  var className = props.className,
      _props$isTry = props.isTry,
      isTry = _props$isTry === void 0 ? true : _props$isTry,
      _props$btnType = props.btnType,
      btnType = _props$btnType === void 0 ? 'banner' : _props$btnType,
      btnWidth = props.btnWidth;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("section", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_4___default().btnGroup), !!className && className),
    children: [isTry && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      category: btnType,
      btnWidth: btnWidth,
      type: "primary",
      color: "green",
      className: 'btnTry',
      href: "/try",
      children: "\u7ACB\u5373\u8BD5\u7528"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      category: btnType,
      btnWidth: btnWidth,
      type: "primary",
      href: "/contact",
      children: "\u8054\u7CFB\u9500\u552E"
    })]
  });
};
/* harmony default export */ __webpack_exports__["Z"] = (IndexView);

/***/ }),

/***/ 86546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ arrowIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16569);
/* harmony import */ var utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94142);
/* harmony import */ var components_contact__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53784);
/* harmony import */ var components_tdk__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6071);
/* harmony import */ var components_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89231);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17140);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var components_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66817);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);













var IMG_PRE_PATH = 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/solution/group/';
var arrowIcon = [IMG_PRE_PATH + 'pc/c515db6e741040c0727791f18132f0ca5565c2cbcf8223339f990b2058e57726.png', IMG_PRE_PATH + 'pc/d5196741d402f021a87e049a9e4da1f7a7308c02907b20536c00ce03c9e026ee.png', IMG_PRE_PATH + 'pc/7291b3b9646024ce59bf0f0dfe3ab4bf1419de5a035f5a546409019e54f09ef8.png'];

var SkeletonNew = function SkeletonNew(props) {
  var _props$headFixed = props.headFixed,
      headFixed = _props$headFixed === void 0 ? false : _props$headFixed,
      headBg = props.headBg,
      _props$headBgM = props.headBgM,
      headBgM = _props$headBgM === void 0 ? '' : _props$headBgM,
      _props$caseList = props.caseList,
      caseList = _props$caseList === void 0 ? [] : _props$caseList,
      scene = props.scene,
      advantage = props.advantage,
      challenge = props.challenge,
      frame = props.frame,
      frameSrc = props.frameSrc,
      frameSrcM = props.frameSrcM,
      tdkWord = props.tdkWord,
      pageTitle = props.pageTitle,
      desc = props.desc,
      title = props.title,
      simpleDesc = props.simpleDesc;
  var size = (0,utils_hooks_useResize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      currentPage = _useState[0],
      setCurrentPage = _useState[1];

  var currentDate = caseList[currentPage];
  var total = caseList.length;
  var stopAct = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  var container = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      idx = _useState2[0],
      setIdx = _useState2[1];

  var currentActive = currentDate[idx];
  var timerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var tabs = total > 1 && new Array(total).fill('') || [];

  var next = function next() {
    setCurrentPage((currentPage + 1) % total);
  }; //eslint-disable-next-line react-hooks/exhaustive-deps


  var play = function play() {
    clearTimer();
    if (stopAct.current) return;
    timerRef.current = setInterval(function () {
      // traverse to next page
      if (idx >= currentDate.length - 1) {
        setIdx(0);
        next();
      } else {
        setIdx(function (idx) {
          return idx + 1;
        });
      }
    }, 3000);
  };

  var onScroll = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var clientScreen = document.documentElement.clientHeight;

    if (container.current) {
      var _container$current$ge = container.current.getBoundingClientRect(),
          top = _container$current$ge.top;
      /* 当元素出现在视口当中 */


      if (top < clientScreen) {
        play();
      }
    }
  }, [play]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.addEventListener('scroll', onScroll, true);
    return function () {
      window.removeEventListener('scroll', onScroll);
      clearTimer();
    };
  }, [onScroll]);
  /* 移动端时 无滚动时 触发动画*/

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _container$current;

    if (!((_container$current = container.current) !== null && _container$current !== void 0 && _container$current.scrollTop)) {
      onScroll();
    }
  }, [onScroll]);

  var clearTimer = function clearTimer() {
    timerRef.current && clearInterval(timerRef.current);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(components_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    layoutClass: classnames__WEBPACK_IMPORTED_MODULE_2___default()(!headFixed && (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().layout)),
    headerClass: classnames__WEBPACK_IMPORTED_MODULE_2___default()(!headFixed && (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().nav)),
    children: [tdkWord ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_tdk__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      pageKey: tdkWord
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("title", {
        children: ["\u5C0F\u9C7C\u6613\u8FDE-\u89E3\u51B3\u65B9\u6848-", pageTitle]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("header", {
      style: {
        backgroundImage: "url(".concat(size.width < 768 ? headBgM !== null && headBgM !== void 0 ? headBgM : headBg : headBg, ")")
      },
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().header),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
          className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mainTitle),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().title),
            children: title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().simpleDesc),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
              className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().arrowIcon),
              src: arrowIcon[0],
              alt: ""
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
              className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().descContent),
              children: simpleDesc
            })]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
          className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mainContext),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().desc), 'for-pc'),
            dangerouslySetInnerHTML: {
              __html: desc.replace(/\n/g, '<br/>')
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().desc), 'for-mobile'),
            dangerouslySetInnerHTML: {
              __html: desc.replace(/\n/g, '')
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_contact__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            isTry: false,
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().contact), 'for-pc'),
            btnType: 'newBtn',
            btnWidth: 190
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            category: 'newBtn',
            type: "primary",
            href: "/contact",
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().contact), 'for-mobile'),
            children: "\u8054\u7CFB\u9500\u552E"
          })]
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().challenge)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sectionTitle),
        children: "\u884C\u4E1A\u6311\u6218"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().challengeContent),
        children: challenge.map(function (item) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().challengeItem), tdkWord === 'emergency' && (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().special)),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
              src: item.icon,
              alt: item.title
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().itemTitle), 'for-pc'),
                dangerouslySetInnerHTML: {
                  __html: "".concat(item.title).replace(/\n/g, '')
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().itemTitle), 'for-mobile', tdkWord === 'emergency' && (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().twoLine)),
                dangerouslySetInnerHTML: {
                  __html: "".concat(item.title).replace(/\n/g, '<br/>')
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().itemDesc),
                children: item.desc
              })]
            })]
          }, item.title);
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().frame),
      style: {
        backgroundImage: "url(".concat(size.width < 768 ? frameSrcM !== null && frameSrcM !== void 0 ? frameSrcM : frameSrc : frameSrc, ")")
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
          className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sectionTitle),
          children: "\u4E1A\u52A1\u65B9\u6848\u6846\u67B6"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().frameContent),
          children: frame.map(function (item) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
              className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().frameItem),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
                alt: item.title,
                src: item.icon,
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().itemIcon)
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().itemTitle),
                children: item.title
              })]
            }, item.title);
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().line)
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().scene),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().advantage),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
          className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sectionTitle),
            children: "\u6838\u5FC3\u4F18\u52BF"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().advantageContent),
            children: advantage.map(function (item) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().advantageItem),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                  className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().advantageHeader),
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
                    alt: item.title,
                    src: item.icon,
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().itemIcon)
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().itemTitle),
                    children: item.title
                  })]
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
                  className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().itemDesc),
                  dangerouslySetInnerHTML: {
                    __html: item.desc.replace(/\n/g, '<br/>')
                  }
                })]
              }, item.title);
            })
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sectionTitle),
        children: "\u5E94\u7528\u573A\u666F"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sceneContent),
        children: scene.map(function (item) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sceneItem),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
              className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().left),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().itemTitle),
                children: item.title
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().itemDesc),
                children: item.desc
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().arrowIcon),
                src: arrowIcon[1],
                alt: ""
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
              className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().pcUrl),
              src: item.pcUrl,
              alt: item.title
            })]
          }, item.title);
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["case"]),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().sectionTitle),
        children: "\u5178\u578B\u6848\u4F8B"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().caseContent),
        ref: container,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
          className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().leftArea),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().logos),
            children: currentDate.map(function (item, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().logo), index === idx && (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().choose)),
                src: item.logo,
                alt: item.title,
                onClick: function onClick() {
                  stopAct.current = true;
                  setIdx(index);
                  clearTimer();
                }
              }, item.title);
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().point),
            children: tabs.map(function (item, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().pagePoint), index === currentPage && (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().active)),
                onClick: function onClick() {
                  setCurrentPage(index);
                  setIdx(0);
                }
              }, index);
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          isNextLink: false,
          href: currentActive.link || '',
          needTarget: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().mask), (tdkWord === 'medical' || tdkWord === 'finance') && (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().decrease)),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
              className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().introduce),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().title),
                children: currentActive.title
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().desc),
                children: [currentActive.desc, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {})]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                isNextLink: false,
                href: currentActive.link || '',
                needTarget: true,
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().learnMore),
                children: "\u4E86\u89E3\u66F4\u591A >"
              })]
            })
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_contact__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["contact-footer"])),
        btnType: 'newBtn'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("img", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().arrowIcon),
        src: arrowIcon[2],
        alt: ""
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SkeletonNew);

/***/ }),

/***/ 6071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tdk; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/utils/tdk.ts
var TDK = {
  // 首页
  home: {
    title: '小鱼易连_视频会议_远程会议_超融合云视频会议系统_政府/企业数字化转型服务商',
    desc: '云视频、超融合云视频、视频会议、远程会议、视频会议系统、企业数字化转型',
    keyword: '小鱼易连创新打造“高安全·超融合·全连接”云视频会议，远程会议系统，专注为党政军央企，金融，学校，医院等大型组织及企业提供超融合视讯协作应用服务，领先通过等保三级+可信云双认证，实现国密算法端到端全链路加密。'
  },
  // 云视频会议
  product: {
    title: '小鱼易连_云视频会议系统_远程会议软件',
    desc: '小鱼易连打造“高安全·超融合·全连接”云视频会议系统,专注为党政军央企等大型组织及企业提供超融合视讯协作应用服务,领先通过等保三级+可信云双认证,实现国密算法端到端全链路加密。',
    keyword: '视频会议系统，视频会议软件，远程会议系统'
  },
  // 云视频平台
  productPlatform: {
    title: '小鱼易连_云视频平台',
    desc: '小鱼易连超融合云视频平台，通过统一的软件定义架构和安全设计，打造统一的支撑开发平台，保证视频会议、直播、点播、监控的融合互通，为全行业用户带来高品质的音视频体验。',
    keyword: '云视频平台'
  },
  // 智能硬件
  hardware: {
    title: '小鱼易连_云视频会议智能硬件_远程会议智能硬件',
    desc: '小鱼易连提供满足全场景应用的云视频会议智能硬件，包括大中小、室内外多场景终端，支持政务内外网、行业专网、互联网、4G/5G、卫星网等多网络灵活接入，实现个性化业务应用。',
    keyword: '云视频会议智能硬件'
  },
  // H.323硬件会议
  h323hardware: {
    title: '小鱼易连_H.323硬件会议_远程会议',
    desc: '小鱼易连H.323硬件会议，支持H.323/SIP标准，为传统H.323/SIP产品提供云视频体验，兼容异构品牌视频会议。',
    keyword: 'H.323硬件会议'
  },
  // 软件客户端
  productClient: {
    title: '小鱼易连_云视频会议软件客户端',
    desc: '小鱼易连云视频会议软件客户端，适用于Windows、Mac、iOS/Android客户端音视频互动、内容共享、会议主持、直播、录制、点播等功能。',
    keyword: '云视频会议软件客户端'
  },
  // 指挥调度客户端
  commandDispatch: {
    title: '小鱼易连_云视频会议指挥调度客户端',
    desc: '小鱼易连云视频会议指挥调度客户端，用于管理员或指挥调度人员进行专业会议管理、综合视频调度，可对内部所有会议或会场进行监管，并对接监控平台构建一体化的会议与监控融合调度平台。',
    keyword: '云视频会议指挥调度客户端'
  },
  // 未来教育
  education: {
    title: '小鱼易连_未来教育',
    desc: '小鱼易连面向未来教育，打造教育全融合视频互动解决方案，借助统一教育视频应用平台，实现互动、直播、点播、资源分享、教学管理、AI智能等多场景融合应用，促进教育均衡发展。',
    keyword: '未来教育'
  },
  // 教育视频能力中枢
  videoCenter: {
    title: '小鱼易连_教育视频能力中枢_未来教育',
    desc: '小鱼易连教育视频能力中枢，以核心云视频技术优势，实现高清流畅的音视频交互体验，为学校、教师、学生提供专业的音视频云服务，打破地区教育发展瓶颈，助力教育公平和均衡发展。',
    keyword: '教育视频能力中枢'
  },
  // 教育资源管理平台
  educationPlatform: {
    title: '小鱼易连_教学管理与资源平台_未来教育',
    desc: '小鱼易连教学管理与资源平台是支撑互动课堂的核心教学平台，包含云录播和直播、协同备课、远程教研、在线督导、教学运维、数据分析、资源汇聚、资源管理等多应用。',
    keyword: '教学管理与资源平台'
  },
  // 智能互动教学终端
  educationTerminal: {
    title: '小鱼易连_智能视频互动教学终端_未来教育',
    desc: '小鱼易连智能互动教学终端，以云视频技术为核心，以教学业务为指导，帮助教育用户轻松实现课程资源建设、三个课堂、网络教研、教育直播、家校互动的常态化应用，助力教育资源优质均衡。',
    keyword: '智能互动教学终端'
  },
  // 小鱼易连开发平台
  api: {
    title: '小鱼易连_开发平台',
    desc: '小鱼易连打造具备业务和场景创新能力、支持API和SDK定制化接入的泛业务开发平台，是可视数字化新连接广泛完善和不断深化的创新支撑。',
    keyword: '开发平台'
  },
  // 互动音视频
  apiAv: {
    title: '小鱼易连_互动音视频',
    desc: '小鱼易连提供全平台SDK及API接口，能与主流的办公协同应用对接和集成，提供安全、稳定、高清的互动音视频服务，适用协同办公、在线教育、金融双录、视频客服、远程医疗等应用。',
    keyword: '互动音视频'
  },
  // 多方会议调度
  apiDispatch: {
    title: '小鱼易连_多方会议调度',
    desc: '小鱼易连通过与各种指挥调度、业务管理、可视化等系统进行快速对接和集成，提供多方会议调度能力，广泛应用于会议会商、指挥调度、指挥党建、远程调解、互动培训等应用场景。',
    keyword: '多方会议调度'
  },
  // 互动会议直播
  apiLive: {
    title: '小鱼易连_互动会议直播',
    desc: '小鱼易连互动会议直播，通过易用的直播和录播API接口集成，可以快速实现大型活动、远程培训、企业年会、智慧党建、营销活动的直播或点播应用，单场并发规模可达百万级。',
    keyword: '互动会议直播'
  },
  // 教育api产品
  apiEducation: {
    title: '小鱼易连_教育API产品',
    desc: '小鱼易连教育API产品，接口功能覆盖引擎管理、课程及用户管理、音视频通话质量管理及课内外应用状态监测等全业务流程，可协助客户快速完成从前端教学应用到运维及后台管理的完整业务体系开发。',
    keyword: '教育API产品'
  },
  // 政务行业
  govSolution: {
    title: '小鱼易连_政府服务行业云视频会议解决方案',
    desc: '小鱼易连提供自主创新云视频技术和政务云视频顶层设计方案，将云视频应用从会议室延展到个人互联、移动接入、融合调度、政务服务等多场景，全面提升政务数字化水平，助力政府数字化转型。',
    keyword: '政府服务行业云视频会议解决方案'
  },
  //政法行业
  govLow: {
    title: '小鱼易连_智慧政法行业数字化解决方案',
    desc: '小鱼易连通过构建一体化“智慧政法”全融合云视频平台，促进司法行政效率和公共法律服务水平提升，助力执法规范化、管理精细化、服务透明化，推进法治现代化建设。',
    keyword: '智慧政法行业数字化解决方案'
  },
  // 企业集团
  group: {
    title: '小鱼易连_企业集团行业智能云会议/协同办公解决方案',
    desc: '小鱼易连通过“高安全·超融合·全连接”的云视频整体解决方案，深度融合企业集团业务需求，可高效支撑企业远程会议、协同办公、视频客服等日常或定制场景应用，赋能企业集团数字化转型升级。',
    keyword: '企业集团行业智能云会议解决方案，企业集团行业协同办公解决方案'
  },
  // 金融行业
  finance: {
    title: '小鱼易连_金融行业数字化转型解决方案',
    desc: '小鱼易连以“数字化、科技引领、创新驱动”为整体布局驱动，为金融行业提供安全、便捷的云视频中台服务，适应金融业务需求和网络条件灵活部署，助力金融机构实现管理数字化、科技化、智能化。',
    keyword: '金融行业数字化转型解决方案'
  },
  // 教育行业
  eduSolution: {
    title: '小鱼易连_教育行业解决方案',
    desc: '教育全融合视频互动解决方案，以云视频互动技术为核心，实现互动教学、同步课堂、远程教研、督导巡课、视频会议、考场监控、校园安全等智慧教育场景的融合应用，为教育用户构建教、学、研、管、评及组织办公协同的一站式音视频应用生态体系，促进教育优质均衡，实现“蓝天下·同课堂”。',
    keyword: '教育行业解决方案'
  },
  // 医疗行业
  medical: {
    title: '小鱼易连_医疗行业分级诊疗解决方案',
    desc: '小鱼易连通过整合业务系统为远程医疗提供数据及流程支撑，打造全流程、全网络、全场景、全贯通、全业务的远程医疗平台，帮助患者实现远程就医，提升基层医生医疗水平，提高医疗救治服务效率，推动基层医疗发展，促进分级诊疗，优化医疗资源配置，创新互联网医院发展模式，推动区域医疗协同发展。',
    keyword: '医疗行业分级诊疗解决方案'
  },
  //水利行业
  waterConservancy: {
    title: '小鱼易连_水利行业智慧水利解决方案',
    desc: '小鱼易连打造集水利会议系统、监控系统、单兵系统、指挥车等于一体的音视频集控系统，满足大规模、多场景、广覆盖、全业务嵌入的内外部高清视频沟通需求，赋能数字孪生水利工程建设，助力水利治理、防汛抗旱等日常智慧管理。',
    keyword: '水利行业智慧水利解决方案'
  },
  //应急行业
  emergency: {
    title: '小鱼易连_应急行业云视频解决方案',
    desc: '小鱼易连采用云计算与虚拟化技术，构建一体化“应急指挥融合平台”，通过标准音视频通信协议与各级单位、部门机构的视频系统实现互通互联，实现全时空、多部门、多业务的视频协同，让应急指挥直达一线，加快推进应急管理体系现代化。',
    keyword: '应急行业云视频解决方案'
  },
  // 法院
  court: {
    title: '小鱼易连_法院视频会议解决方案',
    desc: '小鱼易连法院视频会议解决方案，通过“高安全·超融合·全连接”云视频，可实现互联网庭审、多方协调、一乡一庭、移动法庭、庭审直播、远程庭审等，让司法程序高效便捷。',
    keyword: '法院视频会议解决方案'
  },
  // 检察院
  procuratorate: {
    title: '小鱼易连_检察院视频会议解决方案',
    desc: '小鱼易连检察院视频会议解决方案，通过“高安全·超融合·全连接”云视频，高效实现检法协同、远程汇报、分析讲座、远程提审、三方提审等多场景应用，实现检务工作智慧化。',
    keyword: '检察院视频会议解决方案'
  },
  // 税务
  tax: {
    title: '小鱼易连_税务视频会议解决方案',
    desc: '小鱼易连税务视频会议解决方案，依托“高安全·超融合·全连接”云视频技术，实现多级会议、在线交流、纳服协作、数据管税、税务普法等应用。',
    keyword: '税务视频会议解决方案'
  },
  // 远程办公
  telecommuting: {
    title: '小鱼易连_企业远程办公视频会议解决方案',
    desc: '小鱼易连提供远程办公视频会议解决方案，员工使用PC/Mac、手机，通过家庭宽带或4G网络就能实现多方高清会议，可共享Word、PPT、Excel等各种文档，会后还可生成音视频记录。',
    keyword: '企业远程办公视频会议，远程办公视频会议解决方案'
  },
  // 在线课堂
  onlineTeaching: {
    title: '小鱼易连_在线课堂视频会议解决方案',
    desc: '小鱼易连在线课堂视频会议解决方案，助力停课不停学。在社会应急或特殊时期，老师可在校使用专业云视频硬件终端或在家使用电脑授课，学生在家用电脑、平板或手机上课，可实时双向交流。',
    keyword: '在线课堂视频会议解决方案'
  },
  // 交通行业
  traffic: {
    title: '小鱼易连_交通行业视频会议远程会议解决方案',
    desc: '小鱼易连交通行业视频会议解决方案，以“高安全·超融合·全连接”的云视频技术，助力交通行业信息化建设，满足视频沟通、应急处理、统一调度、综合执法、巡查巡检等业务应用需求。',
    keyword: '交通行业视频会议解决方案'
  },
  // 核心优势
  advantage: {
    title: '小鱼易连_远程视频会议核心优势',
    desc: '小鱼易连远程视频会议核心优势业内领先，超大规模的运营级云视频平台、AI智能超高清会议、领先“SVC+AVC”双引擎架构、全面自主安全可靠。',
    keyword: '远程视频会议核心优势'
  },
  // 公司新闻
  news: {
    title: '小鱼易连_视频会议新闻资讯_让世界零距离',
    desc: '小鱼易连创新打造“高安全·超融合·全连接”云视频,专注为党政军央企等大型组织及企业提供超融合视讯协作应用服务，实时更新视频会议新闻资讯。',
    keyword: '视频会议新闻资讯'
  },
  // 三个课堂
  threeClass: {
    title: '小鱼易连_三个课堂',
    desc: '小鱼易连三个课堂解决方案采用“云+硬件终端+开发平台+AI“整体架构，连接区域内、区域间优质校和薄弱校，为全体师生构建高质量的学习、教研、培训和交流的平台与通道。咨询热线：400-900-3567。',
    keyword: '三个课堂'
  },
  //超融合视频平台
  platform: {
    title: '小鱼易连_超融合云视频平台解决方案',
    desc: '超融合云视频平台解决方案',
    keyword: '小鱼易连采用新一代智能云化架构和先进的音视频算法，功能丰富，性能强大，部署灵活，易管易用，为用户提供安全、稳定、高品质的音视频体验。'
  }
};
var getTdk = function getTdk(key) {
  if (!TDK[key]) return TDK['home'];
  return TDK[key];
};
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/tdk/index.tsx






var Index = function Index(props) {
  var _getTdk = getTdk(props.pageKey),
      title = _getTdk.title,
      keyword = _getTdk.keyword,
      desc = _getTdk.desc;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "keywords",
      content: keyword
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "description",
      content: desc
    })]
  });
};

/* harmony default export */ var tdk = (Index);

/***/ }),

/***/ 95965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H2": function() { return /* binding */ GOV_IMG_PRE_PATH; },
/* harmony export */   "HW": function() { return /* binding */ GROUP_IMG_PRE_PATH; },
/* harmony export */   "K": function() { return /* binding */ WATER_IMG_PRE_PATH; },
/* harmony export */   "PY": function() { return /* binding */ MED_IMG_PRE_PATH; },
/* harmony export */   "XZ": function() { return /* binding */ EDU_IMG_PRE_PATH; },
/* harmony export */   "ZV": function() { return /* binding */ FIN_IMG_PRE_PATH; },
/* harmony export */   "jH": function() { return /* binding */ LINK_PRE_PATH; },
/* harmony export */   "kD": function() { return /* binding */ LAW_IMG_PRE_PATH; },
/* harmony export */   "vr": function() { return /* binding */ UrlPre; },
/* harmony export */   "vs": function() { return /* binding */ EME_IMG_PRE_PATH; }
/* harmony export */ });
var EDU_IMG_PRE_PATH = 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/solution/education/';
var LAW_IMG_PRE_PATH = 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/solution/governmentLaw/';
var GROUP_IMG_PRE_PATH = 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/solution/group/';
var GOV_IMG_PRE_PATH = 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/solution/governmentAffair/';
var LINK_PRE_PATH = 'https://www.xylink.com/news/';
var EME_IMG_PRE_PATH = 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/solution/emergency/';
var FIN_IMG_PRE_PATH = 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/solution/finance/';
var MED_IMG_PRE_PATH = 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/solution/medical/';
var WATER_IMG_PRE_PATH = 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/solution/waterConservancy/';
var UrlPre = 'https://sdk-source.xylink.com/website/assets/solutions/';

/***/ }),

/***/ 39465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ edu_solution; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/solution/skeletonNew/index.tsx
var skeletonNew = __webpack_require__(86546);
// EXTERNAL MODULE: ./src/constants/solution/index.ts
var solution = __webpack_require__(95965);
;// CONCATENATED MODULE: ./src/constants/solution/edu-solution.ts

var headBg = solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/aaa6db883da9a09773e46769a8722e1dd81b08f3f5c96ab7e25275298819185f.jpg';
var headBgM = solution/* EDU_IMG_PRE_PATH */.XZ + 'm/731b54a45ab7d1d4c3e0882ca58e1df3d46d790f5dd74e42b239c730305b92fa.jpg';
var frameSrc = solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/90cd32e219a4fd5f7ff75145f656b3b8e29ebee3188f9bd90d80512c1fbb01a8.jpg';
var frameSrcM = solution/* EDU_IMG_PRE_PATH */.XZ + 'm/ac441bac6d164b51d407f4882429fc0e73c85b142c7617d17ce8694079fa357a.jpg';
var challenge = [{
  icon: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/a760015a1f24e9c5e975c5d91d48409514682fd2085c41ced17873435787a9a9.png',
  title: '教育资源不均，乡镇基础薄弱',
  desc: '城乡教育资源分配不均衡，欠发达地区教育资源不足，资金短缺，教育基础设施薄弱'
}, {
  icon: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/030a0ef289ba3b3e316b9c45b345994fef8e5086012b0161e2a249c9f3120b81.png',
  title: '教学研管等场景难常态化应用',
  desc: '教育流程未全面打通，无法实现创新特色应用，难以满足教学、教研、办公、管理一体化需求'
}, {
  icon: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/a4d75affa16921c9768f3e86654e5908312b76536a482eb1e78b4761dffbc3cf.png',
  title: '校园音视频系统应用孤岛化',
  desc: '视频会议、线上授课、录播教室相互独立，众多品牌无法互联互通，亟需打破各系统的孤岛式应用现状'
}, {
  icon: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/438c4f4a88b1cc5f7d674ea8a02d51119f866aa9ce5261562bb3797c7b4a09d2.png',
  title: '学校无专职技术人员，运维成本高',
  desc: '基层学校无配备技术管理人员，传统教学系统长期缺乏维护管理，使用及维护门槛高'
}];
var edu_solution_frame = [{
  title: '优质资源共享',
  icon: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/7c74c21c687138495e8994a03fe49f01e6ad3899b0056f890ffffd2641ea313f.png'
}, {
  title: '贯穿教学研管',
  icon: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/c7d33fbc161ab456aac6ca55d527dcef59aebdfc7f068f721bd8e660fa3dac7c.png'
}, {
  title: '多系统融合互通',
  icon: solution/* LAW_IMG_PRE_PATH */.kD + 'pc/9a401e6f963dbfae539d904cea119af56658ef3786911cfc2703411c4101ba84.png'
}, {
  title: '降低运维成本',
  icon: solution/* GROUP_IMG_PRE_PATH */.HW + 'pc/fa946d09390c3fcd3af2352b6b5bcd62b7bf84a5fbfa8bb4630e69090dcb790d.png'
}];
var advantage = [{
  icon: solution/* GROUP_IMG_PRE_PATH */.HW + 'pc/68979ad392e91c378cf24b24c95fffd44bfc3d080c65373c0a037be1314f36c8.png',
  title: '超融合应用',
  desc: '视频会议、直播、录播、数据、语音等统一媒体接入能力，可融合多品牌录播、视频会议、监控、安防等系统，全域视频能力中台，构建教/学/研/评/管/办公一站式生态体系'
}, {
  icon: solution/* GROUP_IMG_PRE_PATH */.HW + 'pc/faf1f6749cd9696565108b7f79fbfdd524c6bfce90020c55138f9eaf87719206.png',
  title: '全场景连接',
  desc: '提供全连接视频终端，满足各类教学空间、办公会议、集控中心、户外移动场景、家庭等全场景接入，突破空间及地域限制，实现全连接、常态化、多场景的强扩展性应用'
}, {
  icon: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/2732eb8a44e1ad1d8a067523a0e5bf69a35e2fa5c3b623fdf26759b8dc086cdd.png',
  title: '灵活化部署',
  desc: '平台提供公有云、私有云、专有云等多种部署方式，基于各级教育部门及机构业务，灵活开展特色化部署，可实现数据本地流转，资源文件本地存储'
}, {
  icon: solution/* GOV_IMG_PRE_PATH */.H2 + 'pc/ba7fb7ba0a0f40557012ce829250051134a7fa360fd790dde54e3b843ca4fa6a.png',
  title: '高安全保密',
  desc: '国密算法端到端全链路加密，适配各类信创CPU芯片、操作系统和数据库，全面兼容国产化平台，符合国家自主安全战略'
}, {
  icon: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/6a2161742892a9fb040270ee993fa78fc033e954dfaabb16c39edbb7e2a96953.png',
  title: '高品质体验',
  desc: '全自研底层技术，具备完全自主核心知识产权，超强网络适应性，有效保障超大规模、超低延时的1080P/4K超高清体验'
}, {
  icon: solution/* GROUP_IMG_PRE_PATH */.HW + 'pc/72abb4a6fb3e84800a01164b1497efa20ae197c93d1213928156bb947035a3b0.png',
  title: '开放式集成',
  desc: '全面开放API/SDK，深度融合教育应用场景，打造音视频数字基座，促进学校音视频业务互通的基础能力提升'
}];
var scene = [{
  title: '专递课堂',
  desc: '实现优秀主讲老师本地教学的同时，远程为多地区、多课堂学生上课',
  pcUrl: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/fb310447437efb6cb9343c8c2ddeb7ac61954129dcff3e35f135d2f27f6371f5.jpg'
}, {
  title: '双师课堂',
  desc: '真人1:1还原主讲老师课堂，偏远地区学生可实时与老师课堂互动',
  pcUrl: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/9bf6786454db487c08e6cd35f35fa748f9497e0d618b15731737cf7881f0e129.jpg'
}, {
  title: '停课不停学 ',
  desc: '支持万方接入，可快速搭建线上云课堂平台，实现大规模在线教学',
  pcUrl: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/6b3a4b73d518d420565f22cd0caeb3a519a04fb5a8e0c4464e8324f0d33249f5.jpg'
}, {
  title: '家校互通',
  desc: '发挥名师示范效应，组建网络研修共同体，提升区域师资教研水平',
  pcUrl: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/7be73150727eec27ff86c6006f5cd5825e8daf4dcba1ffdb8e5a09aad7d9e8cb.jpg'
}, {
  title: '名师课堂',
  desc: '满足大规模4K互动视频商务洽谈需求，可实现异地多方音频、视频、数据共享等远程协作',
  pcUrl: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/15044cc518d1e8e4096a152b0ce3bd03e242b1ee724758e857470f846f74fec7.jpg'
}, {
  title: '网络教研',
  desc: '突破时空限制开展远程教学研讨，支持课件共享、实时标注等',
  pcUrl: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/78814ca5cc7551240cf8c6232f6588ac95603a429e49e8bbfef0e347032f2115.jpg'
}, {
  title: '教师培训',
  desc: '支持区域大规模视频会议进行教育课堂研讨，各终端可随时随地入会',
  pcUrl: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/342951493fe3d86d0dcc8dc73f9ef057d6105b77e20e3235a042b8adeb0d1533.jpg'
}, {
  title: '督导巡课',
  desc: '校园管理部门可对教学过程进行实时抽样督导，了解教学实况',
  pcUrl: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/fec801e79f9e20f86c88bc04679724750815b17aef4b0024e5382e5df2f41103.jpg'
}];
var caseList = [[{
  logo: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/f2d71eddf706e25974fb2eb9e00b8e2344a43e0966191fb9f901e6799c01d10a.png',
  title: '云南省教育厅',
  desc: '云南省教育厅携手小鱼易连，搭建服务教育应用的教育融合云视频平台以及千余套互动教学终端系统，实现全省1+N远程互动课堂、教研共同体、协同办公（日常工作会议、控辍保学、疫情防控调度会议、线上家长会）、思政课堂等多元常态化应用。2020年，云南省教育厅举办了“春季开学第一课”培训活动。通过云视频在互联网环境下，直播主课堂与直播分课堂建立高清视频连接，让全省5万多间教室的200万师生实现在线同步上课。',
  link: solution/* LINK_PRE_PATH */.jH + '175774'
}, {
  logo: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/1626da1f132be39edac2ba90d4811c784baa982cb43748e393784c57027805d3.png',
  title: '内蒙古包头市教育局',
  desc: '疫情面前勇往无前，云端上课温情不减。内蒙古包头市教育局，借助小鱼易连，积极组织全市近10万名初高中学生在家上课学习，通过云视频进行“远程在线授课、互动答疑”，老师和学生实时在线面对面“空中课堂”学习。针对高三学生， “互动课堂”实现对全市15000名高三学生全覆盖，将原本校内复习备考的课程搬到线上，让孩子们从容应对高考。',
  link: solution/* LINK_PRE_PATH */.jH + '1063'
}, {
  logo: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/6eb17da31e6fb2b86f88accf0987277009fde3494601539804763e2dcbd0c7fc.png',
  title: '广东省惠州市教育局',
  desc: '广东省惠州市教育局携手小鱼易连，采用“1+N”与“双师课堂”相结合形式，为下辖7个县（区）和贵州省黔西南州7个县（市）的123个分会场，进行“班主任心理健康教育专项”线上远程培训活动。云视频打破时间和物理空间桎梏，让2.65万名老师实现“同屏相连、同台培训”。',
  link: solution/* LINK_PRE_PATH */.jH + '1063'
}, {
  logo: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/bd1413e00b4525b358535e5b4918f5cc1719850eee2d19653c5a4097418bb2bd.png',
  title: '浙江省舟山市岱山县教育局',
  desc: '浙江省舟山市岱山县教育局通过小鱼易连云视频打造智慧课堂，以网络课堂形式确保学生“停课不停学”。师生通过云视频高清连线，开展线上授课、实时互动的在线课堂，课后学生通过录屏回看进行复习巩固，进一步提升学习效果。同时，云视频也加强了老师与家长之间实时沟通，能够在复课之前及时了解学生们的情况。',
  link: solution/* LINK_PRE_PATH */.jH + '954'
}, {
  logo: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/e650a5015b1118f44d8667ca0d3a5cbe455a424fef6283ee056d255c780d336d.png',
  title: '云南省施甸县教育局',
  desc: '云南省施甸县为推动全县教育优质均衡发展，运用信息化手段扩大优质教育资源覆盖面的有效机制建设，深入开展“三个课堂”常态化应用。施甸县携手小鱼易连，基于教育网及互联网，构建全县13个乡镇的互联互通教学应用服务体系，为近百所学校搭建“超高清、低延时、强互动”的互动云课堂。',
  link: solution/* LINK_PRE_PATH */.jH + '7125bf'
}, {
  logo: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/ad76eaa5270509fa13e3e9f2e50c6fbf7defff06b6fbaebf6c3e8ce599c5f075.png',
  title: '浙江省宁波市鄞州区教育局',
  desc: '在浙江省宁波市鄞州区，小鱼易连为“居家观察”的老师和学生搭建线上“超高清、低延时、强互动”的高品质“云课堂”。在校师生在互动教室内上课，居家的老师和学生使用电脑、平板和手机，通过互联网高清接入“云课堂”，进行互动教学。小鱼易连创新的互动教学模式，保障了鄞州区疫情期间教学活动正常进行，实现“停课不停学”。',
  link: solution/* LINK_PRE_PATH */.jH + '1063'
}], [{
  logo: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/ca6edc857b9a514b8d1be51d4ad01d1a5f63d393b5fcaf48b2e2f7f17579b1ff.png',
  title: '温州市瓯海区教育局',
  desc: '瓯海教育局携手小鱼易连，共同打造瓯海教育云视频平台，实现了教育局、辖区110余所中小学和幼儿园、6个直属机构、全区5000多位公办教师和教职工的全覆盖，满足远程视频会议、办公协同、网络教研、在线听评课、线上师训、活动直播等教育教学、办公场景应用，为全区的数字教育及协作沟通提供强有力保障，并与教育教学相关业务进行深度融合，为全区教育信息化升级工作提供新思路。',
  link: solution/* LINK_PRE_PATH */.jH + '5ec7ce'
}, {
  logo: solution/* EDU_IMG_PRE_PATH */.XZ + 'pc/659ca0ad3a40a95d4e45daef826db3be90759a3722183ffcb1c2aa81c4c7a092.png',
  title: '巴蜀云校',
  desc: '巴蜀云校是应用5G和云视频等先进技术打造的巴蜀教育综合体，致力于通过小鱼易连云视频，联动各合作区域智慧教室，将巴蜀中学优质教育教学资源输送到友好学校，实现优质教育资源的共享共建。基于云视频打造的适合初级中学、高完中、高级中学各学龄阶段的线上“面对面”教育教学系统，为推进教育公平铺平道路。',
  link: solution/* LINK_PRE_PATH */.jH + '5befeb'
}]];
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/pages/edu-solution.tsx
/**
 * 教育行业
 */





var Education = function Education() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(skeletonNew/* default */.Z, {
    headFixed: true,
    challenge: challenge,
    caseList: caseList,
    advantage: advantage,
    scene: scene,
    frame: edu_solution_frame,
    headBg: headBg,
    headBgM: headBgM,
    title: "\u6559\u80B2\u884C\u4E1A\u89E3\u51B3\u65B9\u6848",
    simpleDesc: "\u84DD\u5929\u4E0B \xB7 \u540C\u8BFE\u5802",
    desc: "\u6559\u80B2\u5168\u878D\u5408\u89C6\u9891\u4E92\u52A8\u89E3\u51B3\u65B9\u6848\uFF0C\u4EE5\u4E91\u89C6\u9891\u4E92\u52A8\u6280\u672F\u4E3A\u6838\u5FC3\uFF0C\u5B9E\u73B0\u4E92\u52A8\u6559\u5B66\u3001\u540C\u6B65\u8BFE\n\u5802\u3001\u8FDC\u7A0B\u6559\u7814\u3001\u7763\u5BFC\u5DE1\u8BFE\u3001\u89C6\u9891\u4F1A\u8BAE\u3001\u8003\u573A\u76D1\u63A7\u3001\u6821\u56ED\u5B89\u5168\u7B49\u667A\u6167\u6559\u80B2\u573A\u666F\u7684\u878D\u5408\u5E94\n\u7528\uFF0C\u4E3A\u6559\u80B2\u7528\u6237\u6784\u5EFA\u6559\u3001\u5B66\u3001\u7814\u3001\u7BA1\u3001\u8BC4\u53CA\u7EC4\u7EC7\u529E\u516C\u534F\u540C\u7684\u4E00\u7AD9\u5F0F\u97F3\u89C6\u9891\u5E94\u7528\u751F\u6001\u4F53\n\u7CFB\uFF0C\u4FC3\u8FDB\u6559\u80B2\u4F18\u8D28\u5747\u8861\u53D1\u5C55\uFF0C\u5B9E\u73B0\u201C\u84DD\u5929\u4E0B\xB7\u540C\u8BFE\u5802\u201D\u3002",
    pageTitle: "\u6559\u80B2\u884C\u4E1A",
    tdkWord: "eduSolution",
    frameSrc: frameSrc,
    frameSrcM: frameSrcM
  });
};

/* harmony default export */ var edu_solution = (Education);

/***/ }),

/***/ 94142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var UseResize = function UseResize() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    width: 0
  }),
      size = _useState[0],
      setSize = _useState[1];

  var onResize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    setSize({
      width: document.documentElement.clientWidth
    });
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.addEventListener('resize', onResize);
    return function () {
      window.removeEventListener('resize', onResize);
    };
  }, [onResize]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    onResize();
  }, [onResize]);
  return size;
};

/* harmony default export */ __webpack_exports__["Z"] = (UseResize);

/***/ }),

/***/ 16911:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/edu-solution",
      function () {
        return __webpack_require__(39465);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"contact_border__px__DM3ZN","border__px-before":"contact_border__px-before__F0Vlr","border__px-before1":"contact_border__px-before1__wOrFT","border-children1":"contact_border-children1__bFQeI","border-children2":"contact_border-children2__8WMsP","for-mobile":"contact_for-mobile__SdQT9","for-pc":"contact_for-pc__7iuGe","btnGroup":"contact_btnGroup__Glj3p"};

/***/ }),

/***/ 17140:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"case":"skeletonNew_case__NSk7Y","scene":"skeletonNew_scene__lLMR1","advantage":"skeletonNew_advantage__LffP6","content":"skeletonNew_content__fI46r","advantageContent":"skeletonNew_advantageContent__7k21M","advantageItem":"skeletonNew_advantageItem__P6nTl","advantageHeader":"skeletonNew_advantageHeader__Nd9Y_","frame":"skeletonNew_frame__m5Xiw","challenge":"skeletonNew_challenge__ENcsR","border__px":"skeletonNew_border__px__96pPO","border__px-before":"skeletonNew_border__px-before__Z0G7_","border__px-before1":"skeletonNew_border__px-before1__pyPfK","border-children1":"skeletonNew_border-children1__9UzQ1","border-children2":"skeletonNew_border-children2__NrWlV","for-mobile":"skeletonNew_for-mobile__32sGa","for-pc":"skeletonNew_for-pc__1XWVe","challengeContent":"skeletonNew_challengeContent__0xXHO","layout":"skeletonNew_layout__zUh5r","nav":"skeletonNew_nav__vBJ1_","header":"skeletonNew_header__hHjSq","title":"skeletonNew_title__ZrXIu","simpleDesc":"skeletonNew_simpleDesc__MZhRu","arrowIcon":"skeletonNew_arrowIcon__eu5i1","descContent":"skeletonNew_descContent__gJoeS","desc":"skeletonNew_desc__48z3M","contact":"skeletonNew_contact__RRQPT","contact-footer":"skeletonNew_contact-footer__bYNI_","sectionTitle":"skeletonNew_sectionTitle__7X0n_","itemTitle":"skeletonNew_itemTitle__PSGaJ","itemDesc":"skeletonNew_itemDesc__Pr6WR","challengeItem":"skeletonNew_challengeItem__tO7_f","frameContent":"skeletonNew_frameContent__Ogamf","frameItem":"skeletonNew_frameItem__fQv0z","itemIcon":"skeletonNew_itemIcon__UuIR5","line":"skeletonNew_line__hEAf5","sceneContent":"skeletonNew_sceneContent__TZGTu","sceneItem":"skeletonNew_sceneItem__lmL_T","left":"skeletonNew_left__tvesR","pcUrl":"skeletonNew_pcUrl__iC2pE","fly":"skeletonNew_fly__xUFfm","caseContent":"skeletonNew_caseContent__LeLPH","leftArea":"skeletonNew_leftArea__oISiS","logos":"skeletonNew_logos__K9ORA","logo":"skeletonNew_logo__EUseG","choose":"skeletonNew_choose__1e_s_","word":"skeletonNew_word__IhxjU","point":"skeletonNew_point__tlyiF","pagePoint":"skeletonNew_pagePoint__lvocr","active":"skeletonNew_active__aT46B","mask":"skeletonNew_mask__OmxWn","introduce":"skeletonNew_introduce__ZedUw","learnMore":"skeletonNew_learnMore__pLAh6","mainTitle":"skeletonNew_mainTitle__5rHSg","mainContext":"skeletonNew_mainContext__Ke_ON","twoLine":"skeletonNew_twoLine__Bggok","special":"skeletonNew_special__RG_qb","context":"skeletonNew_context__yb7i4","decrease":"skeletonNew_decrease__TTI3N"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1012,9774,2888,179], function() { return __webpack_exec__(16911); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);